module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bDk6w"))).then(() => module.bundle.root('f4eak'));